import React, { FC, memo } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop'
import HelpIcon from '@ucheba/ui/icons/icon__help.svg'
import { ExternalLogo } from '@ucheba/ui/components/ExternalLogo/desktop'
import { IInstitutionsListRankingProps } from '../types'
import SC from '../base/InstitutionsListRanking.styles'
import { rankingHash } from '../../InstitutionsRanking/constants'

const { Block } = SC

/** Вуз в рейтинге */
const InstitutionsListRanking: FC<IInstitutionsListRankingProps> = (props) => {
  const { id, logo, place, tooltip } = props

  return (
    <Block>
      <ExternalLogo
        logo={logo}
        height='18px'
        maxWidth='80px'
        href={`/for-abiturients/vuz/rankings#${rankingHash}-${id}`}
        maxHeight='unset'
      />

      <Text fontWeight='semibold'>{`${place} в России`}</Text>

      <Tooltip width='320px' position='top-center' content={tooltip} html>
        <HelpIcon width='20px' height='20px' />
      </Tooltip>
    </Block>
  )
}

export { InstitutionsListRanking }
export default memo(InstitutionsListRanking)
